
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ContactForm from '@/components/ContactForm';
import SEO from '@/components/SEO';

// Import refactored components
import HeroSection from './HeroSection';
import ServiceDescription from './ServiceDescription';
import ProcessSection from './ProcessSection';

const NetworkInfrastructure: React.FC = () => {
  return (
    <div className="min-h-screen">
      <SEO 
        title="Network & Infrastructure Services"
        description="Build a reliable and secure foundation for your business operations with our comprehensive network and infrastructure solutions."
        canonicalUrl="https://itmgmtsol.com/services/network-infrastructure"
      />
      <Navbar />
      
      {/* Hero Section */}
      <HeroSection />
      
      {/* Service Description Section */}
      <ServiceDescription />
      
      {/* Process Section */}
      <ProcessSection />
      
      {/* Contact Form */}
      <ContactForm />
      
      <Footer />
    </div>
  );
};

export default NetworkInfrastructure;
